import './styles.scss';
import { registerFragment } from '@neptune/cx/registry';

registerFragment('chroa-recent-discussion-card', (fragmentElement, configuration, meta) => {});

if (import.meta.hot) {
    import.meta.hot.accept();
}

const overLink = document.querySelector<HTMLAnchorElement>('#overLink');
const disclink = document.querySelector<HTMLAnchorElement>('#disclink');

if (disclink?.getAttribute("class") === "logged-out") {
    overLink?.setAttribute("href", "/c/portal/login?redirect=" + disclink.getAttribute("href"));
} else {
    overLink?.setAttribute("href", disclink?.getAttribute("href") || '');
}

